module.exports = __webpack_public_path__ + "static/media/Aubrey_O.b3055a85.jpg";